import React, { forwardRef, ReactNode } from "react";

import ChevronRightOutlinedIcon from "@mui/icons-material/ChevronRightOutlined";

import * as Styled from "./LeadIssueRow.styled";
import { LeadIssueSeverity } from "./LeadIssueRow.styled";

export interface LeadIssueRowProps {
    label: string;
    count: number;
    severity: LeadIssueSeverity;
    icon: ReactNode;
    onClick: () => void;
}

/**
 * One actionable issue on a connection card: a full-width row that opens the
 * lead issue dialog. Built on ButtonBase so ripple, keyboard activation and
 * focus-visible come from MUI rather than being re-implemented on a div.
 */
const LeadIssueRow = forwardRef<HTMLButtonElement, LeadIssueRowProps>(
    ({ label, count, severity, icon, onClick }, ref) => (
        <Styled.IssueRow
            ref={ref}
            severity={severity}
            onClick={onClick}
            aria-haspopup="dialog"
        >
            <Styled.IssueIcon severity={severity}>{icon}</Styled.IssueIcon>
            <Styled.IssueLabel>{label}</Styled.IssueLabel>
            <Styled.IssueCount severity={severity}>{count}</Styled.IssueCount>
            <Styled.IssueChevron className="lead-issue-chevron">
                <ChevronRightOutlinedIcon fontSize="small" />
            </Styled.IssueChevron>
        </Styled.IssueRow>
    ),
);

LeadIssueRow.displayName = "LeadIssueRow";

export const LeadIssueList = Styled.IssueList;

export default LeadIssueRow;
